import { Layer1ShadowEvaluation } from '../../services/lossStructureApi';

interface Props {
  evaluation: Layer1ShadowEvaluation;
}

const STATUS_LABELS = {
  measurable: '측정 가능',
  partial: '부분 표본',
  insufficient: '표본 부족',
};

export default function LossLayer1Shadow({ evaluation }: Props) {
  return (
    <div className="loss-layer1-shadow">
      <div className="loss-section-heading">
        <div>
          <h4>PR3 Shadow 후보 평가</h4>
          <p className="loss-subnote">
            실제 차단/청산 없이 후보 룰이 어떤 종목과 표본에 걸리는지만 계산한다.
          </p>
        </div>
        <span className="loss-pill">shadow-only</span>
      </div>

      <div className="loss-shadow-grid">
        {evaluation.candidates.map((candidate) => (
          <article className="loss-shadow-card" key={candidate.key}>
            <div className="loss-shadow-topline">
              <strong>{candidate.label}</strong>
              <span className={`loss-shadow-status ${candidate.status}`}>
                {STATUS_LABELS[candidate.status]}
              </span>
            </div>
            <div className="loss-shadow-impact">
              <span>영향 표본</span>
              <strong>{candidate.would_block_count}건</strong>
            </div>
            <p>{candidate.risk_reduced_hint}</p>
            <div className="loss-shadow-symbols">
              {candidate.affected_symbols.length > 0
                ? candidate.affected_symbols.join(', ')
                : '해당 종목 없음'}
            </div>
          </article>
        ))}
      </div>

      <ul className="loss-notes">
        {evaluation.notes.map((note) => <li key={note}>{note}</li>)}
      </ul>
    </div>
  );
}
